// PERF (2026-07-17): rAF throttle. Coalesces bursts of resize events into at most
// one call per animation frame.
function rafThrottle(fn) {
    var queued = false;
    return function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
            queued = false;
            fn();
        });
    };
}

$(document).ready(function () {
    Slider();
    position_Product__Info();

    $(document).on('click', '[data-trigger-menu-drawer]', function (e) {
        $('.header__icon--menu').trigger("click");
    });

    $('.section--overflow').on('click', '.readMore-btn', function (e) {
        e.preventDefault();

        $(this).closest('.section--overflow').toggleClass('in');

        if ($(this).closest('.section--overflow').hasClass('in')) {
            $(this).html('<span>Read less</span>');
        } else {
            $(this).html('<span>Read more</span>');
        }
    });

         $('[data-description-read-more]').on('click', function (e) {
          e.preventDefault();
        
          const $accordion = $('[data-accordion-description]');
          const $trigger = $accordion.find('[data-accordion-trigger]');
        
          $('html, body').animate({
            scrollTop: $accordion.offset().top
          }, 500, function () {
            // Mark as intentional open to avoid interfering with scroll
            $trigger.data('scroll-open', true);
        
            if ($trigger.attr('aria-expanded') === 'false') {
              $trigger.click();
            }
          });
        });


    $(document).on('click', '[data-action="toggle-tab"]', function () {
        var tab_id = $(this).attr('aria-controls');

        $('[data-action="toggle-tab"]').removeClass('is_active');
        $('[data-action="toggle-tab"]').attr('aria-selected', 'false');
        $('.TabPanel').attr('aria-hidden', 'true');

        $(this).addClass('is_active');
        $(this).attr('aria-selected', 'true');
        $('#' + tab_id).attr('aria-hidden', 'false');
    });

    $('[data-action="open-drawer"]').on('click', function () {
        if ($('body').hasClass('template-cart') == false) {
            var data = $(this).attr('data-drawer-id');
            $('#' + data).addClass('active');
            $('.PageOverlay').addClass('is-visible');
            $('body').addClass('overflow-hidden');
        }
    });
    
    $(document).on('click', '[data-action="close-drawer"]', function (e) {
        var data = $(this).attr('data-drawer-id');
        $('#' + data).removeClass('active');
        $('.PageOverlay').removeClass('is-visible');
        $('body').removeClass('overflow-hidden');
    });

      $(document).on('click', '[data-accordion-trigger]', function (e) {
      e.preventDefault();
  
        const $trigger = $(this);
        const $accordion = $trigger.closest('[data-accordion]');
        const $content = $accordion.find('[data-accordion-content]');
        const isOpen = $trigger.attr('aria-expanded') === 'true';
      
        // If triggered by the Read More scroll, allow it
        const triggeredByScroll = $trigger.data('scroll-open') === true;
      
        // Update state
        $trigger.attr('aria-expanded', !isOpen);
        $content.stop(true, true).slideToggle();
      
        // Clear the flag so future clicks don't scroll
        if (triggeredByScroll) {
          $trigger.removeData('scroll-open');
        }
  });


    $(document).on('click', '[data-action="AddAddress"]', function () {
        var customer_content = $(this).closest('[data-customer-addresses]');
        var AddAddress = customer_content.find('#AddAddress');
        var address_list = customer_content.find('.customer_content');

        if ($(this).attr('aria-expanded') === 'false') {
            address_list.show();
            AddAddress.hide();

            if ($(window).width() < 990) {
                $(this).show();
            }
        } else {
            address_list.hide();
            AddAddress.show();
            if ($(window).width() < 990) {
                $(this).hide();
            }
        }
    });

    $(document).on('click', '[data-action="Close_AddAddress"]', function () {
        var customer_content = $(this).closest('[data-customer-addresses]');

        customer_content.find('#AddAddress').hide();
        customer_content.find('.customer_content').show();
        $('[data-action="AddAddress"]').attr('aria-expanded', 'false');
    });

    $(".header__menu-lv2")
        .mouseenter(function _openMenu(event, target) {
            var parent = $(this).parent('details')
            parent.attr('open', true);
            var header__submenu = parent.find(".header__submenu");
            header__submenu
                .mouseover(function () {
                    parent.attr('open', true);
                })
                .mouseout(function () {
                    parent.removeAttr('open');
                });
        })
        .mouseleave(function _closeMenu(event, target) {
            $(this).parent('details').removeAttr('open');
        });

    // PERF (2026-07-17): was bound to 'scroll resize', so position_Product__Info()
    // ran on EVERY scroll tick -- calling appendTo() to physically move a DOM node
    // and forcing a synchronous layout recalculation dozens of times a second while
    // scrolling a product page. Viewport width cannot change on scroll, so this only
    // needs to react to resize. position_Product__Info() additionally bails out now
    // unless the 1240px breakpoint has actually been crossed.
    $(window).on('resize', rafThrottle(position_Product__Info));

  $('.contact_bottom_menu ').click(function(){
  	$(this).find('.contact_bottom_menu_inner').toggleClass('menu_open');
  });
  
});

function Slider() {
    $(".announcement--slider").each(function () {
        var settings_slideshow = $(this).data('slick-config');
        // 2026-07-20: switched from the default horizontal slide (hard 300ms snap,
        // read as "jerky") to a slow cross-fade with easing. pauseOnHover so a
        // message can be read without it swapping mid-read.
        $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            speed: 800,
            cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
            pauseOnHover: true,
            autoplay: settings_slideshow['autoplay'],
            autoplaySpeed: settings_slideshow['autoplaySpeed'],
            arrows: false,
            dots: false,
            loop: true,
            prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg viewBox="0 0 14 24"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-39.000000, -468.000000)" stroke="currentColor"><g transform="translate(0.000000, 120.000000)"><polyline transform="translate(46.000000, 360.000000) scale(-1, 1) translate(-46.000000, -360.000000) " points="40 348 52 360 40 372"/></g></g></g></svg></button>',
            nextArrow: '<button type="button" class="slick-arrow slick-next"><svg viewBox="0 0 14 24"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-1387.000000, -468.000000)" stroke="currentColor"><g transform="translate(0.000000, 120.000000)"><polyline points="1388 348 1400 360 1388 372"/></g></g></g></svg></button>',
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        arrows: settings_slideshow['arrows'],
                    }
                }
            ]
        });
    });

    $(".section_slideshow").each(function () {
        var Slideshow__Carousel = $(this).find('.Slideshow__Carousel');
        var settings_slideshow = Slideshow__Carousel.data('slick-config');

        Slideshow__Carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: settings_slideshow['autoplay'],
            autoplaySpeed: settings_slideshow['autoplaySpeed'],
            dots: settings_slideshow['dots'],
            arrows: settings_slideshow['arrows'],
            prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg viewBox="0 0 14 24"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-39.000000, -468.000000)" stroke="currentColor"><g transform="translate(0.000000, 120.000000)"><polyline transform="translate(46.000000, 360.000000) scale(-1, 1) translate(-46.000000, -360.000000) " points="40 348 52 360 40 372"/></g></g></g></svg></button>',
            nextArrow: '<button type="button" class="slick-arrow slick-next"><svg viewBox="0 0 14 24"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(-1387.000000, -468.000000)" stroke="currentColor"><g transform="translate(0.000000, 120.000000)"><polyline points="1388 348 1400 360 1388 372"/></g></g></g></svg></button>',
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
    });

    $(".section_featured-collection").each(function () {
        var Slideshow__Carousel = $(this).find('.ProductList--slider');
        var settings_slideshow = Slideshow__Carousel.data('slick-config');
        var Slideshow__Next = $(this).find('.slider-button--next');
        var Slideshow__Prev = $(this).find('.slider-button--prev');

        // Section renders a static grid when the 'Swipe' setting is off, so there is
        // no carousel to initialise and no slick config to read. Bail out safely.
        if (!Slideshow__Carousel.length || !settings_slideshow) return;

         Slideshow__Carousel.slick({
            slidesToShow: settings_slideshow['slidesToShow'],
            slidesToScroll: settings_slideshow['slidesToShow'],
            centerMode: false,
            dots: false,
            arrows: true,
            responsive: [
                {
                  breakpoint: 1100,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false
                  }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '40px',
                        dots: true
                    }
                }
            ]
        });

        Slideshow__Next.on('click', function() {
          Slideshow__Carousel.find('.slick-next').click();
        });

        Slideshow__Prev.on('click', function() {
          Slideshow__Carousel.find('.slick-prev').click();
        });
    });

    $(".section_featured-blog").each(function () {
        var Slideshow__Carousel = $(this).find('.BlogList--slider');

        Slideshow__Carousel.slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: false,
            arrows: false,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        dots: true
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });
    });

    $(".section_multicolumn").each(function () {
        var Slideshow__Carousel = $(this).find('.multicolumn--slider');
        var settings_slideshow = Slideshow__Carousel.data('slick-config');

        // Same guard as the featured collection above.
        if (!Slideshow__Carousel.length || !settings_slideshow) return;

        Slideshow__Carousel.slick({
            slidesToShow: settings_slideshow['slidesToShow'],
            slidesToScroll: settings_slideshow['slidesToShow'],
            dots: true,
            arrows: true,
            prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg viewBox="0 0 11 18"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-34.000000, -437.000000)" stroke="currentColor" stroke-width="2"><g transform="translate(0.000000, 158.000000)"><g transform="translate(40.000000, 288.000000) scale(-1, 1) translate(-40.000000, -288.000000) translate(20.000000, 268.000000)"><polyline points="16 12 24 20 16 28"/></g></g></g></g></svg></button>',
            nextArrow: '<button type="button" class="slick-arrow slick-next"><svg viewBox="0 0 11 18"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1395.000000, -437.000000)" stroke="currentColor" stroke-width="2"><g transform="translate(0.000000, 158.000000)"><g transform="translate(1380.000000, 268.000000)"><polyline points="16 12 24 20 16 28"/></g></g></g></g></svg></button>',
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: false,
                    }
                }
            ]
        });
    });

    if($('[data-cart-upsell-carousel]').length > 0) {

        function progressBar(index = 0, count = 1) {
            var progressBar = $('.c-cart-upsell__progress-bar-inner');
            var itemWidth = 100 / count;
            var progress = (index + 1) * itemWidth;

            progressBar.css('width', progress + '%');
        }

        $('[data-cart-upsell-carousel]').on('init', function(event, slick){
            setTimeout(function() {
                progressBar(0, slick.slideCount);
            }, 100);
        });  

        $('[data-cart-upsell-carousel]').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            dots: false,
            arrows: true
        });

        $('[data-cart-upsell-carousel]').on('afterChange', function(event, slick, currentSlide, nextSlide){
            progressBar(currentSlide, slick.slideCount);
        });

        document.querySelectorAll('[data-cart-upsell] [data-carousel-previous]')?.forEach(item => {
            item.addEventListener('click', ()=> {
                item.parentElement.parentElement.querySelector('[data-cart-upsell-carousel] .slick-prev').click();
            });
        })


        document.querySelectorAll('[data-cart-upsell] [data-carousel-next]')?.forEach(item => {
            item.addEventListener('click', ()=> {
                item.parentElement.parentElement.querySelector('[data-cart-upsell-carousel] .slick-next').click();
            });
        })

        if(document.querySelectorAll('[data-cart-upsell-item]').length < 1) {
            document.querySelectorAll('[data-cart-upsell]')?.forEach(item => {
                item.classList.add('is-hidden');
            });
        }
        else if(document.querySelectorAll('[data-cart-upsell-item]').length == 1) {
            document.querySelector('[data-cart-upsell]').classList.add('is-single-product');
          }
    }

    if ($('body').hasClass('template-product') == true) {
        $('.Product__Slideshow').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg viewBox="0 0 11 18"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-34.000000, -437.000000)" stroke="currentColor" stroke-width="2"><g transform="translate(0.000000, 158.000000)"><g transform="translate(40.000000, 288.000000) scale(-1, 1) translate(-40.000000, -288.000000) translate(20.000000, 268.000000)"><polyline points="16 12 24 20 16 28"/></g></g></g></g></svg></button>',
            nextArrow: '<button type="button" class="slick-arrow slick-next"><svg viewBox="0 0 11 18"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1395.000000, -437.000000)" stroke="currentColor" stroke-width="2"><g transform="translate(0.000000, 158.000000)"><g transform="translate(1380.000000, 268.000000)"><polyline points="16 12 24 20 16 28"/></g></g></g></g></svg></button>'
        });
    }

  
    // TABS
    const tabContentProducts = document.querySelectorAll('[data-products-id]');
    const tabButtons = document.querySelectorAll('[data-button-tab-id]');
    const tabImages = document.querySelectorAll('[data-tab-image]');
    const collectionLinks = document.querySelectorAll('[data-link-id]');

    tabButtons?.forEach(button => {
      button.addEventListener('click', (e)=> {
        e.preventDefault();
        const buttonId = button.getAttribute('data-button-tab-id');

        tabButtons?.forEach(button => button.classList.remove('is-active'));
        tabContentProducts?.forEach(button => button.classList.remove('is-active'));
        tabImages?.forEach(button => button.classList.remove('is-active'));
        collectionLinks?.forEach(button => button.classList.remove('is-active'));

        document.querySelector(`[data-products-id="${buttonId}"]`).classList.add('is-active');
        document.querySelector(`[data-button-tab-id="${buttonId}"]`).classList.add('is-active');
        document.querySelector(`[data-tab-image="${buttonId}"]`).classList.add('is-active');
        document.querySelector(`[data-link-id="${buttonId}"]`).classList.add('is-active');
        
        // 2026-07-20: slick removed from shop-by-concern on narrow screens; the
        // products row is a native scroll container now, nothing to resize.
      });
    })

    // PERF (2026-07-17): this block was previously bound to 'scroll resize' and
    // re-invoked .slick() on EVERY scroll event. $(window).width() also forces a
    // synchronous layout read each time, so scrolling any page containing the
    // shop-by-concern section was doing a full carousel re-init per frame.
    //
    // It now runs once on load and thereafter only when the 1240px breakpoint is
    // actually crossed. Side benefit: on mobile the carousels now initialise
    // immediately instead of only after the visitor happens to scroll.
    updateShopConcernCarousels();
    $(window).on('resize', rafThrottle(updateShopConcernCarousels));
}

// Tracks the last known side of the 1240px breakpoint so we only touch the DOM when
// it actually changes. null = not yet evaluated.
var shopConcernIsNarrow = null;

function updateShopConcernCarousels() {
    // 2026-07-20: slick REMOVED for this section on narrow screens. It was
    // initialising a carousel on all six product containers -- five of them
    // display:none at init time -- which produced zero-size broken tracks and
    // an empty products panel on mobile. The pills and product rows are now
    // native horizontal scroll containers (see shop-by-concern.css), which
    // need no JS at all. This function now only cleans up any slick instance
    // left over from a resize while the old code was cached.
    if ($('.c-shop-concern__links-wrapper').hasClass('slick-initialized')) $('.c-shop-concern__links-wrapper').slick('unslick');
    if ($('.c-shop-concern__products.slick-initialized').length) $('.c-shop-concern__products.slick-initialized').slick('unslick');
}

// Tracks the last known side of the 1240px breakpoint, as above.
var productInfoIsNarrow = null;

function position_Product__Info() {
    var isNarrow = $(window).width() < 1240;
    if (isNarrow === productInfoIsNarrow) return;
    productInfoIsNarrow = isNarrow;

    if (isNarrow) {
        $('.product__actions-container').appendTo($('.product__info-wrapper'));
    } else {
        $('.product__actions-container').appendTo($('.product__actions-wrapper'));
    }
}